module.exports = __webpack_public_path__ + "img/ametista.136ae6c8.png";